import { INVOICE_BILLING_TYPES, InvoiceBillingTypeEnum } from '@/enums'
import { InvoiceBillingTypeDataType } from '@/types'

export class InvoiceBillingType {
    key: InvoiceBillingTypeEnum

    title: string

    constructor(data: InvoiceBillingTypeDataType) {
        this.key = data.key
        this.title = data.title
    }

    get isInvoice() {
        return this.key === InvoiceBillingTypeEnum.INVOICE
    }

    get isCreditMemo() {
        return this.key === InvoiceBillingTypeEnum.CREDIT_MEMO
    }

    static get all() {
        return INVOICE_BILLING_TYPES.map(item => new InvoiceBillingType(item))
    }

    static find(key: InvoiceBillingTypeEnum) {
        return InvoiceBillingType.all.find(item => item.key === key) || InvoiceBillingType.defaultType
    }

    static get defaultType() {
        return InvoiceBillingType.all.find(item => item.key === InvoiceBillingTypeEnum.INVOICE) as InvoiceBillingType
    }
}
